document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".review-toggle").forEach(button => {
    button.addEventListener("click", () => {
      const p = button.previousElementSibling; // el <p>
      const fullText = p.getAttribute("data-full");

      if (button.innerText === "Ver más") {
        p.innerText = fullText;
        button.innerText = "Ver menos";
      } else {
        p.innerText = fullText.slice(0, 100) + "...";
        button.innerText = "Ver más";
      }
    });
  });
});
